// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-title[data-v-57421cb6]{margin-bottom:16px;font-size:15px;font-weight:600}.filter-list[data-v-57421cb6]{display:flex;flex-wrap:wrap;gap:16px}.filter-item[data-v-57421cb6]{display:flex;justify-content:center;align-items:center;padding:12px;font-size:16px;border:1px solid #d8d8d8;border-radius:4px;min-width:60px;color:#000;background:transparent}.active.filter-item[data-v-57421cb6]{border-color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
